<template>
    <div>
        <template v-if="onboarding_documents == true">
            <div class="page-top mb-1 mb-3">
                <h1> Add Onboarding Document </h1>
            </div>
            <div class="global-main">
                <form id="onboardingDocumentForm" @submit.prevent="addOnboardingDocument" novalidate>
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Document Title  <em class="required">*</em></label>
                            <input v-model="form.document_title" type="text" name="document_title" class="form-control" :class="{ 'is-invalid': form.errors.has('document_title') }" maxlength="50">
                            <has-error :form="form" field="document_title"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Description  <em class="required">*</em></label>
                            <input v-model="form.description" type="text" name="description" class="form-control" :class="{ 'is-invalid': form.errors.has('description') }" maxlength="150">
                            <has-error :form="form" field="description"></has-error>
                        </div>
                        <div class="form-group">
                            <label class="label block-label"> Account Type <em class="required">*</em></label>
                            <select v-model="form.account_type" name="account_type" class="form-control" :class="{ 'is-invalid': form.errors.has('account_type') }">
                                <option value="" selected>Select Account Type</option>
                                <option v-for="accountType in accountTypes" v-bind:value="accountType.id" v-bind:key="accountType.id">
                                    {{ accountType.type }}
                                </option>
                            </select>
                            <has-error :form="form" field="account_type"></has-error>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <label> Has Sample </label>
                            </div>
                            <div class="col">
                                <label class="form-group toggle_switch">
                                    <input v-model="form.has_sample" name="has_sample" v-on:change="has_status_toggle()" class="toggle_input" type="checkbox">
                                    <span class="toggle_slider toggle_round"></span>
                                </label>
                            </div>
                        </div>
                        <div class="form-group" id="sample_file_div">
                            <label> Sample File </label>
                            <div class="onboarding-main">
                                <div class="row cnic-holder">
                                    <div class="col-md-12">
                                        <div class="form-group upload-outer">
                                            <span class="upload-title"> Upload Sample File </span>
                                            <input type="file" @change="uploadSampleFile($event,'sample_path','sample_path')" class="file-up-btn" accept=".pdf,.doc,.docx" id="sample_path" required/>
                                            <label for="sample_path" class="btn-upload-file">Upload</label>
                                            <span class="uploaded-file"></span>
                                            <label for="sample_path" class="btn-change-file hide"><img src="/images/cross-icon.png" alt=""></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <input v-model="form.sample_file" type="hidden" name="sample_file" class="form-control" :class="{ 'is-invalid': form.errors.has('sample_file') }">
                            <has-error :form="form" field="sample_file"></has-error>
                        </div>    
                        <div class="row">
                            <div class="col-3">
                                <label> Active </label>
                            </div>
                            <div class="col">
                                <label class="form-group toggle_switch">
                                    <input v-model="form.is_active" name="is_active" class="toggle_input" type="checkbox">
                                    <span class="toggle_slider toggle_round"></span>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <label> Required </label>
                            </div>
                            <div class="col">
                                <label class="toggle_switch">
                                    <input v-model="form.is_required" name="is_required" class="toggle_input" type="checkbox">
                                    <span class="toggle_slider toggle_round"></span>
                                </label>
                            </div>
                        </div>
                        <div class="row mt-08">
                            <div class="col-3">
                                <label>Multiple </label>
                            </div>
                            <div class="col">
                                <label class="toggle_switch">
                                    <input v-model="form.is_multiple" name="is_multiple" class="toggle_input" type="checkbox">
                                    <span class="toggle_slider toggle_round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/onboardingDocuments" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="onboarding_documents === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="onboarding_documents === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<style>
    .toggle_switch {
    position: relative;
    display: inline-block;
    width: 55px;
    height: 28px;
    }

    .toggle_switch input { 
    opacity: 0;
    width: 0;
    height: 0;
    }

    .toggle_slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    }

    .toggle_slider:before {
    position: absolute;
    content: "";
    height: 21px;
    width: 21px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    }

    .toggle_input:checked + .toggle_slider {
    background-color: #f15c22;
    }

    .toggle_input:focus + .toggle_slider {
    box-shadow: 0 0 1px #f15c22;
    }

    .toggle_input:checked + .toggle_slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
    }

    /* Rounded toggle_sliders */
    .toggle_slider.toggle_round {
    border-radius: 34px;
    }

    .toggle_slider.toggle_round:before {
    border-radius: 50%;
    }
    .mt-08 {
        margin-top: 0.8rem !important;
    }
</style>
<script>
    export default {
        data() {
            return {
                form: new Form({
                    document_title: "",
                    description: "",
                    has_sample: false,
                    is_active: false,
                    is_required: false,
                    is_multiple: false,
                    account_type: ''
                }),
                companies: {},
                onboarding_documents: null,
                accountTypes: [],
            };
        },
        methods: {
            addOnboardingDocument() {
                let newForm=new FormData();
                $.each(this.form, (key, value) => {
                    newForm.append(key,value);     
                });
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                axios.post('/api/addOnboardingDocument',newForm, config)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.code == '200'){
                            this.showToastBox("success", "OnBoarding Document added successfully");
                            this.$router.push("/onboardingDocuments");
                            this.$Progress.finish();
                        }else{
                            var error_msg = '';
                            error_msg = 'Please provide following details:'+'\n';     
                            $.each(res.data.data, (key, value) => {
                                error_msg += value +'\n';     
                            });
                            this.showAlertBox('error',error_msg);
                            this.$Progress.fail();
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }
                }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            has_status_toggle(){
                if(this.form.has_sample == true) {
                    $('#sample_file_div').show();
                } else {
                    $('#sample_file_div').hide();
                }
            },
            uploadSampleFile(e, id, name) {
                var fileName = e.target.files[0].name;
                var fileExt = e.target.files[0].type;

                $("#"+id).siblings(".uploaded-file").html(fileName);
                $("#"+id).siblings(".btn-change-file").removeClass('hide');
                $("#"+id).siblings(".btn-upload-file").html("").addClass('showimage').prepend('<img src="/images/tick-white.png" alt="">');
                let self=this;
                var files = e.target.files || e.dataTransfer.files;
                if(files.length >0){
                    this.form.sample_file= e.target.files[0];
                }else{
                    this.form.sample_file= '';  
                }
            },
            getAccountTypeFields(){
                axios.get('/api/getCompanyAccountTypes').then(response => {
                    this.accountTypes = response.data.data;
                }).catch(error => {
                    this.showAlertBox('error', 'Error to load Account Types data');
                });
            },
            selectPickerOnchange() {
                const select = this.$el;
                setTimeout(() => {
                    $(select).find('.selectpicker').selectpicker('refresh');
                }, 0);
            },
        },
        mounted() {
            this.$Progress.start();
            this.can("onboarding_documents")
                .then((result) => {
                    this.onboarding_documents = result.onboarding_documents;
                })
                .then((result) => {
                    if (this.onboarding_documents == true) {
                        $('#sample_file_div').hide();
                        this.$Progress.finish();
                    } else {
                        this.$Progress.finish();
                    }
                });
            this.getAccountTypeFields();
        },
    }
</script>
